import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "basic-button" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
      class: _normalizeClass({
                'is-primary': _ctx.buttonType === 'primary',
                'is-gray': _ctx.buttonType === 'gray',
                'is-white': _ctx.buttonType === 'white',
                'is-red': _ctx.buttonType === 'red',
                'is-white-blue': _ctx.buttonType === 'whiteBlue',
                'is-deep-blue-white': _ctx.buttonType === 'deepBlueWhite',
                'is-orange': _ctx.buttonType == 'orange',
            }),
      style: _normalizeStyle({ width: _ctx.width === 0 ? '100%' : _ctx.width + 'px' }),
      disabled: _ctx.isDisabled
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 14, _hoisted_2)
  ]))
}